import { formatearFecha } from "../../../_Utils/fechas";

export const moneyFormatter = new Intl.NumberFormat("es-AR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatMoney = (value) => `$ ${moneyFormatter.format(Number(value || 0))}`;

export const formatDate = (value) => {
  if (!value) return "—";
  try {
    return formatearFecha(value) || value;
  } catch (_error) {
    return value;
  }
};

export const buildConvenioLink = (id) =>
  id ? `/panel/movimientos/cobranzas/convenios-pago/${id}` : null;

export const buildCobranzaLink = (id) =>
  id ? `/panel/movimientos/cobranzas/detalle/${id}` : null;

export const buildCuentaCorrienteLink = (propietarioId) =>
  propietarioId ? `/panel/ctacte-propietario/${propietarioId}` : null;

export const buildPropietarioHubLink = (propietarioId) =>
  propietarioId ? `/panel/propietarios/hub/${propietarioId}` : null;

export const joinChainIds = (ids = []) =>
  (ids || []).filter((item) => item !== null && item !== undefined && item !== "").join(" -> ");

export const downloadBlobResponse = (response, fallbackName) => {
  const blob = new Blob([response.data], {
    type:
      response.data?.type ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  const disposition = response.headers?.["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/i);
  link.href = url;
  link.download = match?.[1] || fallbackName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const exportRowsToCsv = ({ filename, columns, rows }) => {
  const headers = columns.map((column) => column.header);
  const lines = [
    headers.join(";"),
    ...rows.map((row) =>
      columns
        .map((column) => {
          const rawValue = typeof column.value === "function" ? column.value(row) : row[column.value];
          const stringValue = rawValue === null || rawValue === undefined ? "" : String(rawValue);
          return stringValue.includes(";") ? `"${stringValue.replace(/"/g, '""')}"` : stringValue;
        })
        .join(";")
    ),
  ];
  const blob = new Blob([`\uFEFF${lines.join("\n")}`], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
